import(/* webpackMode: "eager" */ "/codebuild/output/src1758541852/src/apps/webapp/src/app/global-error.tsx");
